/** @format */

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Loader from "react-loader-spinner";
import { FiArrowUp, FiArrowDown } from "react-icons/fi";
import ReactPaginate from "react-paginate";
import { useSelector, useDispatch } from "react-redux";

import { toastMessage } from "../../utils/toast";
import { create, getAll,paymentLinkExportCsv, payVoucher } from "../../Redux/Actions/paymentLink";
import { useSortableData } from "../../utils/sortableData";
import DataCount from "../../utils/dataCount";
import { dateTimeFormat } from "../../utils";
import {
  setFilterId,
  setFilterName,
  setFilterMobileNumber,
  setFilterEmail,
  setFilterStatus,
  setFilterFromDate,
  setFilterToDate,
  setFilterFromDateForCreate,
  setFilterToDateForCreate,
  setFilterClearFilterFlag,
  reset,
  setFilterRequestedBy,
} from "../../Redux/Reducers/paymentLinkFilter";

const statusOption = [
  { option: "Initiated", value: "Initiated" },
  { option: "Success", value: "Success" },
  { option: "Failed", value: "Failed" },
];

function PaymentLink() {
  let itemsPerPage = 10;
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [data, setData] = useState([]);
  const [amount, setAmount] = useState("");
  const [name, setName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [description, setDescription] = useState("");
  const [buttonLoading, setButtonLoading] = useState(false);
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [pageLoading, setPageLoading] = useState(false);
  const [requestedBy , setRequestedBy ] = useState("");
  const [payVoucherLoading, setPayVoucherLoading] = useState(false);

  const dispatch = useDispatch();

  const {
    filterId,
    filterName,
    filterMobileNumber,
    filterEmail,
    filterStatus,
    filterFromDate,
    filterToDate,
    filterClearFilterFlag,
    filterFromDateForCreate,
    filterToDateForCreate,
    filterRequestedBy
  } = useSelector((state) => state.paymentLinkFilter);
  const { items, requestSort, sortConfig } = useSortableData(data);

  const getAllApi = async () => {
    setPageLoading(true);
    const payload = {
      id: filterId,
      name: filterName,
      mobileNumber: filterMobileNumber,
      email: filterEmail,
      status: filterStatus,
      fromDate: filterFromDate,
      toDate: filterToDate,
      fromDateForCreate:filterFromDateForCreate,
      toDateForCreate:filterToDateForCreate,
      requestedBy:filterRequestedBy,
      serviceType: null
    };

    try {
  
      const res = await getAll(payload);
      if (res?.data) {
        setData(res?.data);
      }
    } catch (err) {
      console.log(err);
    }
    setPageLoading(false);
  };
  const handleDownload = () => {
    setButtonLoading(true);
    const payload = {
      id: filterId,
      name: filterName,
      mobileNumber: filterMobileNumber,
      email: filterEmail,
      status: filterStatus,
      fromDate: filterFromDate,
      toDate: filterToDate,
      fromDateForCreate:filterFromDateForCreate,
      toDateForCreate:filterToDateForCreate,
      requestedBy:filterRequestedBy,
      serviceType: null
    };

    paymentLinkExportCsv(payload).then(res => {
        try {
            toastMessage('info', `Download in progress`);
            var blob = new Blob(["\ufeff", res.data]);
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            var fileName = 'Payment_link_requests.csv';
            link.download = fileName;
            link.click();
            setButtonLoading(false);
        } catch (error) {
            setButtonLoading(false);
            toastMessage('error', "Something went wrong during file download!!");
        }
    }).catch(err => {
        setButtonLoading(false);
        toastMessage('error', "Something went wrong during file download!!");
    });
}
  useEffect(() => {
    getAllApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterClearFilterFlag]);

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(items.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(items.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, items]);

  const clearState = () => {
    setEmail("");
    setAmount("");
    setDescription("");
    setName("");
    setMobileNumber("");
  };

  const handleSend = async () => {
    setButtonLoading(true);
    const payload = {
      description,
      email,
      amount,
      name,
      mobileNumber,
      requestedBy
    };
    try {
      const response = await create(payload);
      if (response.status === 200) {
        toastMessage("success", "Payment link created");
        clearState();
         setTimeout(() => {
            getAllApi();
        }, 4000);
      } else if (response.status === 400) {
        toastMessage("error", response.data.message || "Invalid input");
      } else {
        toastMessage("error", "Unable to create payment link");
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        toastMessage("error", error.response.data.message || "Invalid input");
      } else if (error.response && error.response.data && error.response.data.message) {
        toastMessage("error", error.response.data.message);
      } else {
        toastMessage("error", "Unable to create payment link");
      }
    }
    setButtonLoading(false);
  };

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  const filterHandler = () => {
    if (
      filterEmail ||
      filterId ||
      filterMobileNumber ||
      filterStatus ||
      filterFromDate ||
      filterToDate ||
      filterFromDateForCreate ||
      filterToDateForCreate ||
      filterName||
      filterRequestedBy
    ) {
      dispatch(setFilterClearFilterFlag(filterClearFilterFlag + 1));
    }
  };
  const paymentVoucherHandler = async (id) => {
    setPayVoucherLoading(true);
    try {
      const response = await payVoucher(id);
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;

      var filename="AMPL-" + id;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    } catch (err) {
      console.log(err);
    }
    setPayVoucherLoading(false);
  }

  const handleClearFilter = () => dispatch(reset());

  return (
    <div className="container-fluid">
      <div className="page-title-box">
        <h4 className="page-title mb-2">{t("paymentLink.title")}</h4>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="card card-custom card-stretch gutter-b">
            <div className="card-body py-3">
              <div className="tab-content">
                <div className="d-flex flex-column">
                  <div className="d-flex row">
                    <div className="d-flex justify-content-around">
                      <div>
                        <label className="me-3">{t("paymentLink.email")}</label>
                        <input
                          className="form-control"
                          placeholder={t("paymentLink.emailPlaceholder")}
                          type="text"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                      <div>
                        <label className="me-3">{t("paymentLink.name")}</label>
                        <input
                          className="form-control"
                          placeholder={t("paymentLink.namePlaceholder")}
                          type="text"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </div>
                      <div>
                        <label className="me-3">
                          {t("paymentLink.mobileNumber")}
                        </label>
                        <input
                          className="form-control"
                          placeholder={t("paymentLink.mobileNumberPlaceholder")}
                          type="text"
                          value={mobileNumber}
                          onChange={(e) => setMobileNumber(e.target.value)}
                        />
                      </div>
                      <div>
                        <label className="me-3">{t("paymentLink.amount")}</label>
                        <input
                          className="form-control"
                          placeholder={t("paymentLink.amountPlaceholder")}
                          type="text"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                        />
                      </div>
                      <div>
                        <label className="me-3">
                          {t("paymentLink.description")}
                        </label>
                        <input
                          className="form-control"
                          placeholder={t("paymentLink.descriptionPlaceholder")}
                          type="text"
                          value={description}
                          onChange={(e) => setDescription(e.target.value.replace(/</g, "").replace(/>/g, ""))}
                        />
                      </div>
                      <div>
                        <label className="me-3">
                          {t("paymentLink.requestedBy")}
                        </label>
                        <input
                          className="form-control"
                          placeholder={t("paymentLink.requestedBy")}
                          type="text"
                          value={requestedBy}
                          onChange={(e) => setRequestedBy(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="d-flex justify-content-end my-2">
                      <button
                        className="btn btn-primary d-flex align-items-center"
                        disabled={
                          buttonLoading ||
                          (email && amount && description && name && mobileNumber
                            ? false
                            : true)
                        }
                        onClick={() => handleSend()}
                      >
                        {t("flyerNotification.send")}
                        {buttonLoading && (
                          <Loader
                            type="Oval"
                            color="#fff"
                            height={20}
                            width={20}
                            style={{ marginLeft: "10px" }}
                          />
                        )}
                      </button>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-md-2">
                        <div className="me-3">
                          <label className="mb-1 ms-1 me-3">
                            {t("paymentLink.id")}
                          </label>
                          <input
                            placeholder={t("paymentLink.idPlaceholder")}
                            type="number"
                            className="form-control me-3"
                            name="ID"
                            value={filterId}
                            onChange={(e) => {
                              dispatch(setFilterId(e.target.value));
                            }}
                          />
                        </div>
                      </div>
  
                      <div className="col-md-2">
                        <div className="me-3" style={{ width: "100%" }}>
                          <label className="mb-1 ms-1 me-3">
                            {t("paymentLink.name")}
                          </label>
                          <input
                            placeholder={t("paymentLink.namePlaceholder")}
                            type="text"
                            className="form-control me-3"
                            name="Filter ID"
                            value={filterName}
                            onChange={(e) => {
                              dispatch(setFilterName(e.target.value));
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="me-3" style={{ width: "100%" }}>
                          <label className="mb-1 ms-1 me-3">
                            {t("paymentLink.email")}
                          </label>
                          <input
                            placeholder={t("paymentLink.emailPlaceholder")}
                            type="text"
                            className="form-control me-3"
                            name="ID"
                            value={filterEmail}
                            onChange={(e) => {
                              dispatch(setFilterEmail(e.target.value));
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="me-3" style={{ width: "100%" }}>
                          <label className="mb-1 ms-1 me-3">
                            {t("paymentLink.status")}
                          </label>
                          <select
                            className="form-select me-3"
                            value={filterStatus}
                            onChange={(e) => {
                              dispatch(setFilterStatus(e.target.value));
                            }}
                          >
                            <option value="" disabled={true}>
                              {t("paymentLink.statusPlaceholder")}
                            </option>
                            {statusOption.map(({ option, value }) => (
                              <option key={option} value={value}>
                                {option}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="me-3" style={{ width: "100%" }}>
                          <label className="mb-1 ms-1 me-3">
                            {t("paymentLink.mobileNumber")}
                          </label>
                          <input
                            placeholder={t("paymentLink.mobileNumberPlaceholder")}
                            type="text"
                            className="form-control me-3"
                            name="ID"
                            value={filterMobileNumber}
                            onChange={(e) => {
                              dispatch(setFilterMobileNumber(e.target.value));
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div className="me-3" style={{ width: "100%" }}>
                          <label className="mb-1 ms-1 me-3">
                            {t("paymentLink.requestedBy")}
                          </label>
                          <input
                            placeholder={t("paymentLink.requestedBy")}
                            type="text"
                            className="form-control me-3"
                            name="ID"
                            value={filterRequestedBy}
                            onChange={(e) => {
                              dispatch(setFilterRequestedBy(e.target.value));
                            }}
                          />
                        </div>
                      </div>
                    </div>
  
                    <div className="row">
                      <div className="col-md-3">
                        <div className="me-3">
                          <label className="mb-1 ms-1 me-3">
                            {t("paymentLink.fromDate")}
                          </label>
                          <input
                            type="date"
                            className="form-control me-3"
                            name="From Date"
                            value={filterFromDate}
                            onChange={(e) => {
                              dispatch(setFilterFromDate(e.target.value));
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="me-3">
                          <label className="mb-1 ms-1 me-3">
                            {t("paymentLink.toDate")}
                          </label>
                          <input
                            type="date"
                            disabled={filterFromDate === "" ? true : false}
                            min={filterFromDate}
                            className="form-control me-3"
                            value={filterToDate}
                            onChange={(e) => {
                              dispatch(setFilterToDate(e.target.value));
                            }}
                          />
                        </div>
                      </div>
  
                      {/* Created date filter */}
                      <div className="col-md-3">
                        <div className="me-3">
                          <label className="mb-1 ms-1 me-3">
                            {t("paymentLink.fromDateForCreate")}
                          </label>
                          <input
                            type="date"
                            className="form-control me-3"
                            name="From Date (Created date)"
                            value={filterFromDateForCreate}
                            onChange={(e) => {
                              dispatch(
                                setFilterFromDateForCreate(e.target.value)
                              );
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="me-3">
                          <label className="mb-1 ms-1 me-3">
                            {t("paymentLink.toDateForCreate")}
                          </label>
                          <input
                            type="date"
                            disabled={
                              filterFromDateForCreate === "" ? true : false
                            }
                            min={filterFromDateForCreate}
                            className="form-control me-3"
                            value={filterToDateForCreate}
                            onChange={(e) => {
                              dispatch(setFilterToDateForCreate(e.target.value));
                            }}
                          />
                        </div>
                      </div>
                    </div>
  
                    <div className="row" style={{margin:'5px'}}>
                      <div className="col-md-2 ">
                        <div className="me-3">
                          <button
                            onClick={filterHandler}
                            type="button"
                            className="d-flex px-5 align-items-center btn btn-primary font-weight-bold"
                          >
                            {t("jobsManagement.filters.filter")}
                          </button>
                        </div>
                      </div>
                      <div className="col-md-2">
                        
                        <button
                          onClick={handleClearFilter}
                          type="button"
                          className="px-5 d-flex align-items-center btn btn-primary font-weight-bold"
                        >
                          {t("jobsManagement.filters.clearFilters")}
                        </button>
                      </div>
  
                      <div className="col-md-2">
                        <button
                          onClick={handleDownload}
                          type="button"
                          className="d-flex px-5 align-items-center btn btn-primary font-weight-bold"
                        >
                          {t("refunds.export")}
                        </button>
                      </div>
                    </div>
                    {pageLoading ? (
                      <Loader
                        type="Oval"
                        color="#fff"
                        height={20}
                        width={20}
                        style={{ marginLeft: "10px" }}
                      />
                    ) : (
                      <div
                        className="table-responsive"
                        style={{ width: "100%", overflowX: "scroll" }}
                      >
                        <table className="table tableFreez tablefix table-head-custom table-vertical-center table-head-bg">
                          <thead>
                            <tr className="text-left">
                              <th
                                className="c-pointer"
                                style={{ width: "75px" }}
                                onClick={() => requestSort("id")}
                              >
                                <span
                                  className={
                                    sortConfig && sortConfig.key === "id"
                                      ? "text-secondary"
                                      : "text-dark-75"
                                  }
                                >
                                  {t("filter.id")}{" "}
                                  {sortConfig &&
                                    sortConfig.key === "id" &&
                                    (sortConfig.direction === "ascending" ? (
                                      <FiArrowUp />
                                    ) : (
                                      <FiArrowDown />
                                    ))}
                                </span>
                              </th>
                              <th className="c-pointer" style={{ width: "75px" }}>
                                {t("paymentLink.amount")}
                              </th>
                              <th className="c-pointer" style={{ width: "75px" }}>
                                {t("paymentLink.email")}
                              </th>
                              <th className="c-pointer" style={{ width: "75px" }}>
                                {t("paymentLink.name")}
                              </th>
                              <th className="c-pointer" style={{ width: "75px" }}>
                                {t("paymentLink.mobileNumber")}
                              </th>
                              <th className="c-pointer" style={{ width: "75px" }}>
                                {t("paymentLink.description")}
                              </th>
                              <th className="c-pointer" style={{ width: "75px" }}>
                                {t("paymentLink.status")}
                              </th>
                              <th className="c-pointer" style={{ width: "75px" }}>
                                {t("paymentLink.transactionCompleteDate")}
                              </th>
                              <th className="c-pointer" style={{ width: "75px" }}>
                                {t("paymentLink.createdDate")}
                              </th>
                              <th className="c-pointer" style={{ width: "75px" }}>
                                {t("paymentLink.requestedBy")}
                              </th>
                              <th className="c-pointer" style={{ width: "75px" }}>
                                {t("paymentLink.action")}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentItems?.map(
                              ({
                                id,
                                amount,
                                email,
                                description,
                                createdTime,
                                name,
                                mobileNumber,
                                status,
                                transactionCompleteDate,
                                requestedBy,
                              }) => (
                                <tr key={id}>
                                  <td>
                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                      {id}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                      {amount}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                      {email}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                      {name ? name : "-"}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                      {mobileNumber ? mobileNumber : "-"}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                      {description}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                      {status}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                      {transactionCompleteDate
                                        ? dateTimeFormat(transactionCompleteDate)
                                        : "-"}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                      {dateTimeFormat(createdTime)}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                      {requestedBy}
                                    </span>
                                  </td>
                                  <td>
                                    {status == "Success" && (
                                      <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                        <button
                                          onClick={() =>
                                            paymentVoucherHandler(id)
                                          }
                                          type="button"
                                          disabled={payVoucherLoading}
                                          className="d-flex px-5 align-items-center btn btn-primary font-weight-bold"
                                        >
                                          {"Payment voucher"}
                                        </button>
                                      </span>
                                    )}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                        {pageCount > 1 && (
                          <ReactPaginate
                            breakLabel="..."
                            nextLabel=">"
                            previousLabel="<"
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={5}
                            pageCount={pageCount}
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            previousClassName="page-item"
                            previousLinkClassName="page-link"
                            nextClassName="page-item"
                            nextLinkClassName="page-link"
                            breakClassName="page-item"
                            breakLinkClassName="page-link"
                            containerClassName="pagination"
                            activeClassName="active"
                            renderOnZeroPageCount={null}
                          />
                        )}
                        {data.length === 0 && (
                          <p className="text-center mt-5 mb-5">
                            {t("jobsManagement.noDataAvailable")}
                          </p>
                        )}
                      </div>
                    )}
                    {data.length > 0 && (
                      <DataCount itemOffset={itemOffset} items={items} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  
  
}

export default PaymentLink;
